import { DashboardSlaSlot } from "@redotech/redo-fulfillment-operations-common/views/default-outbound-views";
import { viewSchemas } from "@redotech/redo-views-common/views";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const saveDashboardSlaView = {
  name: "saveDashboardSlaView" as const,
  input: z.object({
    slot: createEnum(DashboardSlaSlot),
    view: viewSchemas["fulfillment-groups"],
  }),
  output: z.object({}),
};
